import { type } from '@/utils/type'


export const UMBCLASSE_REQUEST = type('UMBCLASSE_REQUEST')
export const UMBCLASSE_SUCCESS = type('UMBCLASSE_SUCCESS')
export const UMBCLASSE_ERROR = type('UMBCLASSE_ERROR')

export const UMBCLASSE_ENSURE_LIST = type('UMBCLASSE_ENSURE_LIST')

export const UMBCLASSE_SELECT_DETAIL_REQUEST = type('UMBCLASSE_SELECT_DETAIL_REQUEST')
export const UMBCLASSE_SELECT_DETAIL_SUCCESS = type('UMBCLASSE_SELECT_DETAIL_SUCCESS')
export const UMBCLASSE_SELECT_DETAIL_ERROR = type('UMBCLASSE_SELECT_DETAIL_ERROR')
export const UMBCLASSE_SELECT_DETAIL = type('UMBCLASSE_SELECT_DETAIL')

export const UMBCLASSE_SAVE_REQUEST = type('UMBCLASSE_SAVE_REQUEST')
export const UMBCLASSE_SAVE_SUCCESS = type('UMBCLASSE_SAVE_SUCCESS')
export const UMBCLASSE_SAVE_ERROR = type('UMBCLASSE_SAVE_ERROR')

export const UMBCLASSE_UPDATE_MODIFIED_ADM = type('UMBCLASSE_UPDATE_MODIFIED_ADM')
export const UMBCLASSE_CANCEL_MODIFIED_ADM = type('UMBCLASSE_CANCEL_MODIFIED_ADM')

export const UMBCLASSE_UPDATE_FILTER_ADM = type('UMBCLASSE_UPDATE_FILTER_ADM')